import { apiClientAuth } from "../http/httpClient";


export function MessageApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {
        
       /**
        * @route   GET /api/messages
        * @desc    Récupérer tous les messages avec utilisateurs associés
        * @access  Private (Authentifié)
        */
        findAll: () => https.get(`/api/messages`),

       /**
        * @route   PUT /api/messages/:id/status
        * @desc    Mettre à jour le statut d'un message (marquer comme répondu) : Email de l'administrateur qui confirme la réponse
        * @access  Private (Authentifié)
        * @param   {integer} id - Identifiant du message
        * @middleware validateMessageId - Valide le paramètre ID
        * @middleware validateUpdateStatus - Valide l'email administrateur
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        update: (id) => https.put(`/api/messages/${id}/status`),

       /**
        * @route   GET /api/messages/:id
        * @desc    Récupérer un message spécifique par son ID
        * @access  Private (Authentifié)
        * @param   {integer} id - Identifiant du message
        * @middleware validateMessageId - Valide le paramètre ID
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        findOne: (id) => https.get(`/api/messages/${id}`),

        

      };
}

